import { createSlice } from "@reduxjs/toolkit";
import { WorkerType } from "../models/WorkerType";

const WorkerTypesInitialState: {
	workerTypes: WorkerType[];
} = {
	workerTypes: [],
};

export const WorkerTypesReducer = createSlice({
	name: "__",
	initialState: WorkerTypesInitialState,
	reducers: {
		setWorkerTypes(state, { payload }) {
			state.workerTypes = payload;
		},
	},
});
